import React, { useState, useEffect } from 'react';
import { signOptions } from '../emojiData'; // ✅ 1. Import the new emoji list
import EmojiPicker from './EmojiPicker';   // ✅ 2. Import the new picker component
import SearchableSelect from './SearchableSelect'; // ✅ 1. Import the new component

const Preferences = ({ preferences, onPreferencesChange, selectedGroup, onGroupChange }) => {
const styles = {
    container: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1rem' // Was 2rem
    },
    title: { 
        fontSize: '0.75rem', // Was 1.5rem
        fontWeight: 'bold', 
        color: 'white', 
        textAlign: 'center' 
    },
    select: { 
        padding: '0.4rem', // Was 0.75rem
        fontSize: '0.8rem', // Was 1rem
        border: '1px solid #ccc', 
        borderRadius: '2px', // Was 4px
        width: '100%' 
    },
    tableContainer: {
        maxHeight: '70vh', // Keeping this relative to screen height is often best
        overflowY: 'auto',
        position: 'relative',
    },
    table: { 
        width: '100%', 
        borderCollapse: 'collapse', 
        fontSize: '0.8rem' // Was 1rem
    },
    tableHeader: { 
        padding: '0.4rem', // Was 0.75rem 
        borderBottom: '1px solid rgba(255, 255, 255, 0.3)', // Was 2px
        textAlign: 'right', 
        backgroundColor: '#353535',
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    tableCell: { 
        padding: '0.4rem', // Was 0.75rem
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)', 
        verticalAlign: 'middle' 
    },
    editInput: { 
        width: '100%', 
        padding: '0.25rem', // Was 0.5rem
        border: '1px solid #ccc', 
        borderRadius: '2px', // Was 4px
        fontSize: '0.8rem', // Was 1rem
        direction: 'ltr' 
    },
    editSelect: { 
        width: '100%', 
        padding: '0.25rem', // Was 0.5rem
        border: '1px solid #ccc', 
        borderRadius: '2px', // Was 4px
        fontSize: '0.8rem' // Was 1rem
    },
    toggleCheckbox: { 
        cursor: 'pointer', 
        transform: 'scale(1)' // Was 1.5
    },
    editableText: { 
        cursor: 'pointer' 
    }
};
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const [editingSignIndex, setEditingSignIndex] = useState(null);

    const currencyOptions = ["تومان", "دلار", "ریال", ""];
    const roundingOptions = {
        'none': 'بدون رند کردن',
        'round_10': 'رند یک صفر',
        'round_100': 'رند دو صفر',
        'round_1000': 'رند سه صفر'
    };
    
    const [groupItems, setGroupItems] = useState([]);
    const [editing, setEditing] = useState(null);

    useEffect(() => {
        if (selectedGroup && preferences) {
            const selectedGroupData = preferences.groups.find(g => g.group_number === selectedGroup);
            setGroupItems(selectedGroupData ? selectedGroupData.items : []);
        } else {
            setGroupItems([]);
        }
    }, [selectedGroup, preferences]);

    useEffect(() => {
        setEditing(null);
    }, [selectedGroup]);
    
    const handleGroupChange = (event) => {
        onGroupChange(event.target.value);
    };
   
    // ✅ 4. New handlers for the picker
    const handleOpenPicker = (index) => {
        setEditingSignIndex(index);
        setIsPickerOpen(true);
    };

    const handleSignSelect = (sign) => {
        if (editingSignIndex !== null) {
            handleChange(editingSignIndex, 'item_sign', sign);
        }
        setIsPickerOpen(false);
        setEditingSignIndex(null);
    };
    const handleChange = (index, field, value) => {
        const newPreferences = JSON.parse(JSON.stringify(preferences));
        const groupIndex = preferences.groups.findIndex(g => g.group_number === selectedGroup);
        if (groupIndex === -1) return;
        
        const itemToUpdate = newPreferences.groups[groupIndex].items[index];
        itemToUpdate[field] = value;

        if (field === 'is_selectable' && !value) {
            itemToUpdate['is_visible'] = false;
        }
        onPreferencesChange(newPreferences);
    };

     const groupOptions = preferences.groups.map(group => ({
        value: group.group_number,
        label: group.group_title
    }));

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>ویرایش تنظیمات پیش‌فرض ربات</h2>
            <SearchableSelect
                options={groupOptions}
                value={selectedGroup}
                onChange={onGroupChange}
                placeholder="یک گروه را انتخاب کنید"
            />
            {groupItems.length > 0 && (
                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.tableHeader}>نماد</th>
                                <th style={styles.tableHeader}>عنوان آیتم</th>
                                <th style={styles.tableHeader}>واحد پولی</th>
                                <th style={styles.tableHeader}>ضریب</th>
                                <th style={styles.tableHeader}>افست</th>
                                <th style={styles.tableHeader}>نحوه رند کردن</th>
                                <th style={styles.tableHeader}>قابلیت انتخاب</th>
                                <th style={styles.tableHeader}>نمایش</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupItems.map((item, index) => (
                                <tr key={`${selectedGroup}-${index}`}>
                                    <td style={styles.tableCell}>
                                        <span style={styles.editableText} onClick={() => handleOpenPicker(index)}>
                                            {item.item_sign || 'خالی'}
                                        </span>
                                    </td>
                                    <td style={styles.tableCell}>
                                        {editing?.index === index && editing?.field === 'item_title' ? (
                                            <input style={styles.editInput} type="text" value={item.item_title} onChange={(e) => handleChange(index, 'item_title', e.target.value)} onBlur={() => setEditing(null)} autoFocus />
                                        ) : (
                                            <span style={styles.editableText} onClick={() => setEditing({ index, field: 'item_title' })}>
                                                {item.item_title}
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.tableCell}>
                                        {editing?.index === index && editing?.field === 'currency' ? (
                                            <select style={styles.editSelect} value={item.currency ?? 'تومان'} onChange={(e) => handleChange(index, 'currency', e.target.value)} onBlur={() => setEditing(null)} autoFocus>
                                                {currencyOptions.map(opt => <option key={opt} value={opt}>{opt || 'خالی'}</option>)}
                                            </select>
                                        ) : (
                                            <span style={styles.editableText} onClick={() => setEditing({ index, field: 'currency' })}>
                                                {item.currency || 'تومان'}
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.tableCell}>
                                        {editing?.index === index && editing?.field === 'coefficient' ? (
                                            <input style={styles.editInput} type="number" step="0.00001" value={item.coefficient ?? 1} onChange={(e) => handleChange(index, 'coefficient', e.target.value)} onBlur={() => setEditing(null)} autoFocus />
                                        ) : (
                                            <span style={styles.editableText} onClick={() => setEditing({ index, field: 'coefficient' })}>
                                                {item.coefficient ?? 1}
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.tableCell}>
                                        {editing?.index === index && editing?.field === 'offset' ? (
                                            <input style={styles.editInput} type="number" value={item.offset ?? 0} onChange={(e) => handleChange(index, 'offset', e.target.value)} onBlur={() => setEditing(null)} autoFocus />
                                        ) : (
                                            <span style={styles.editableText} onClick={() => setEditing({ index, field: 'offset' })}>
                                                {item.offset ?? 0}
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.tableCell}>
                                        {editing?.index === index && editing?.field === 'rounding_policy' ? (
                                            <select style={styles.editSelect} value={item.rounding_policy ?? 'round_100'} onChange={(e) => handleChange(index, 'rounding_policy', e.target.value)} onBlur={() => setEditing(null)} autoFocus>
                                                {Object.entries(roundingOptions).map(([key, value]) => <option key={key} value={key}>{value}</option>)}
                                            </select>
                                        ) : (
                                            <span style={styles.editableText} onClick={() => setEditing({ index, field: 'rounding_policy' })}>
                                                {roundingOptions[item.rounding_policy || 'round_100']}
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.tableCell}>
                                        <input style={styles.toggleCheckbox} type="checkbox" checked={item.is_selectable} onChange={() => handleChange(index, 'is_selectable', !item.is_selectable)} />
                                    </td>
                                    <td style={styles.tableCell}>
                                        <input style={styles.toggleCheckbox} type="checkbox" checked={item.is_visible} onChange={() => handleChange(index, 'is_visible', !item.is_visible)} disabled={!item.is_selectable} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
              {/* ✅ 6. Render the EmojiPicker component conditionally */}
            <EmojiPicker
                isOpen={isPickerOpen}
                onClose={() => setIsPickerOpen(false)}
                onSelect={handleSignSelect}
                options={signOptions}
            />
        </div>
    );
};

export default Preferences;